const closeButtonLabel = "Bezárás";
const huHU = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  huHU as default
};
